import { useSearchParams } from "react-router-dom";

import { Welcome } from "~/components/pos/basket/welcome";
import { useEmployee } from "~/providers/store/employee";
import { useOrder } from "~/hooks/queries/orders";
import { hasAttendedSellConfig } from "~/utils/tills/has-attended-sell-config";
import { useCurrentTill } from "~/api/tills/hooks/use-till-current";
import { useCurrentTillLocalisation } from "~/api/tills/hooks/use-till-current/localisation";
import { useBasketContext } from "~/providers/store/basket/context";
import { T } from "@repo/transifex";
import { priceFormatter } from "~/utils/price-formatter";

import { Basket } from "./basket";
import { PaymentSuccess } from "./payment-success";
import { usePathCleaner } from "./use-path-cleaner";

export const Panel = () => {
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get("orderId");

  const { locale, currency } = useCurrentTillLocalisation();

  const { groupName, employeeChildId, employeeCardHex } = useEmployee();
  const isEmpty = useBasketContext((state) => state.isBasketEmpty);

  const { data: till } = useCurrentTill();
  const { data: order, status: orderStatus } = useOrder(orderId);

  usePathCleaner();

  const isUserAuthenticated = Boolean(employeeCardHex || employeeChildId);

  if (!hasAttendedSellConfig(till) && till?.type !== "self-service") {
    throw new Error(
      "This component is only supported for attended and self-service tills"
    );
  }

  if (
    till?.type === "self-service" &&
    isEmpty &&
    groupName === null &&
    !isUserAuthenticated
  ) {
    if (orderId && orderStatus === "pending") {
      return <Skeleton />;
    }

    if (order?.status !== "paid") {
      return <Welcome />;
    }
  }

  if (till.config.skipReceiptPage && isEmpty && order?.status === "paid") {
    return (
      <PaymentSuccess orderId={order.id}>
        {order.unitPriceChangeInclVat === null ? null : (
          <p className="mb-4 text-center text-xl text-text-primary">
            <T
              _str="Change money {change}"
              change={priceFormatter({
                value: order.unitPriceChangeInclVat,
                currency,
                locale
              })}
            />
          </p>
        )}
      </PaymentSuccess>
    );
  }

  return <Basket />;
};

const Skeleton = () => {
  return (
    <div className="flex size-full animate-pulse items-center justify-center bg-slate-100" />
  );
};
